import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AssessAssistantComponent } from '../components/assess-assistant/assess-assistant.component';

@Component({
  selector: 'assessments',
  standalone: true,
  imports: [
    RouterOutlet,
    AssessAssistantComponent
  ],
  templateUrl: './assessments.component.html',
  styleUrl: './assessments.component.css'
})
export class AssessmentsComponent {

}
